<template>
  <div class="col-12">
    <h2>Residential Proxies - Frequently Asked Questions</h2>
  </div>
  <div class="col-md-6">
    <div id="accordion" class="mgb30">
      <div class="card">
        <div class="card-header">
          <a
            class="collapsed card-link"
            data-toggle="collapse"
            href="#collapseOne1"
            aria-expanded="true">
            What is a residential proxy?
            <span></span>
          </a>
        </div>
        <div
          id="collapseOne1"
          class="collapse"
          data-parent="#accordion">
          <div class="card-body">
            A residential proxy is a proxy that represents a regular user. The target will not
            see that you are using a proxy, and the proxy is also not located in a data center.
            Thus the IP has a better reputation.
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-header">
          <a
            class="collapsed card-link"
            data-toggle="collapse"
            href="#collapseOne"
            aria-expanded="true">
            Do the residential proxies support sticky sessions?<span></span>
          </a>
        </div>
        <div
          id="collapseOne"
          class="collapse"
          data-parent="#accordion">
          <div class="card-body">
            <strong>What is a sticky session?</strong><br>A sticky session makes sure
            that your IP does not change during the duration you are browsing. Typically
            you can choose how long a sticky session remains active.<br><br><strong>
            Our support for sticky sessions</strong><br>Unfortunately, we do not support sticky
            sessions at the moment. However, this is on our roadmap for the near future.</div>
        </div>
      </div>
      <div class="card">
        <div class="card-header">
          <a
            class="collapsed card-link"
            data-toggle="collapse"
            href="#collapseTwo">
            Can I filter the residential proxies by country, state, or city?<span></span>
          </a>
        </div>
        <div id="collapseTwo" class=" collapse " data-parent="#accordion">
          <div class="card-body"><strong>Filtering by country</strong><br>Yes, we do support
            country-specific targeting. Please refer
            <a
              href="https://support.proxyscrape.com/new-using-a-specific-country-with-residential-proxies/"
              style="text-decoration: underline;">to our documentation here.</a><br><br>
            <strong>State & city targeting</strong><br>State & city targeting is currently not
            possible with our residential proxies. We are working hard to get these features
            to you in the near future.</div>
        </div>
      </div>
      <div class="card">
        <div class="card-header">
          <a
            class="collapsed card-link"
            data-toggle="collapse"
            href="#collapseThree1">
            Can I filter the residential proxies by ISP or ASN?<span></span>
          </a>
        </div>
        <div
          id="collapseThree1"
          class=" collapse"
          data-parent="#accordion">
          <div class="card-body">
            At the moment, we do not have the option to filter our residential proxies by ISP
            or ASN. However, this is on our roadmap for late this year.
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-header">
          <a
            class="collapsed card-link"
            data-toggle="collapse"
            href="#collapseThree">
            Do you have a trial for the residential proxies?<span></span>
          </a>
        </div>
        <div
          id="collapseThree"
          class=" collapse"
          data-parent="#accordion">
          <div class="card-body">
            We do not provide a trial for the residential proxies. However, we provide a refund
            guarantee if you consumed less than 1GB of traffic with the residential proxies and paid
            with Credit Card or PayPal. For the exact conditions of the refund guarantee,
            please check our terms and conditions.
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-header">
          <a
            class="collapsed card-link"
            data-toggle="collapse"
            href="#collapseFour">
            How many IPs are there per country?<span></span>
          </a>
        </div>
        <div
          id="collapseFour"
          class=" collapse"
          data-parent="#accordion">
          <div
            class="card-body">
            Our residential proxy pool currently consists of 7 million proxies total. At the
            moment, we do not have statistics on the individual countries.
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-6">
    <div id="accordion2" class="mgb30">
      <div class="card">
        <div class="card-header">
          <a
            class="collapsed card-link"
            data-toggle="collapse"
            href="#collapseFive1">
            What are the advantages of residential proxies?<span></span>
          </a>
        </div>
        <div
          id="collapseFive1"
          class="collapse"
          data-parent="#accordion2">
          <div class="card-body">The advantage of residential proxies is their significantly better
            reputation compared to datacenter proxies. For this reason, you are less likely to be
            blocked on sensitive websites.
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-header">
          <a
            class="collapsed card-link"
            data-toggle="collapse"
            href="#collapseFive2">
            Why should I choose a residential proxy?<span></span>
          </a>
        </div>
        <div
          id="collapseFive2"
          class="collapse"
          data-parent="#accordion2">
          <div class="card-body">
            You should choose a residential proxy if you connect to websites that very quickly
            ban your IP address. This is because the residential proxies rotate and will change
            your IP every time you make a new connection. Apart from that, residential proxies
            also have a significantly better IP reputation compared to datacenter proxies.
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-header">
          <a
            class="collapsed card-link"
            data-toggle="collapse"
            href="#collapseFive">
            Does the data reset every month?<span></span>
          </a>
        </div>
        <div
          id="collapseFive"
          class="collapse"
          data-parent="#accordion2">
          <div class="card-body">
            No, the data on your residential proxy account will remain until you have fully
            used it.
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-header">
          <a
            class="collapsed card-link"
            data-toggle="collapse"
            href="#collapseSix">
            How to use the residential package<span></span>
          </a>
        </div>
        <div
          id="collapseSix"
          class="collapse"
          data-parent="#accordion2">
          <div class="card-body">
            The residential proxies work like any other user:pass authenticated proxy. The only
            difference is that the residential proxies rotate. Thus, you can use them as usual
            in any software that supports user:pass proxy authentication.
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-header">
          <a
            class="collapsed card-link"
            data-toggle="collapse"
            href="#collapseSeven">
            What criteria do you use to calculate the data consumption?
            <span></span>
          </a>
        </div>
        <div
          id="collapseSeven"
          class=" collapse"
          data-parent="#accordion2">
          <div class="card-body">
            In order to calculate the data consumption on our residential proxies, we count up
            the download and upload traffic of the HTTP layer.
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-header">
          <a
            class="collapsed card-link"
            data-toggle="collapse"
            href="#collapseEight">
            Is there an API in the residential package?<span></span>
          </a>
        </div>
        <div
          id="collapseEight"
          class=" collapse"
          data-parent="#accordion2">
          <div class="card-body">
            At the moment, our residential proxies do not have an API. We are working on getting
            this implemented once it is out of beta.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang='ts'>

</script>

<style scoped>

</style>
